import { render, staticRenderFns } from "./tab-dot.vue?vue&type=template&id=99b250d2&scoped=true&"
import script from "./tab-dot.vue?vue&type=script&lang=js&"
export * from "./tab-dot.vue?vue&type=script&lang=js&"
import style0 from "./tab-dot.vue?vue&type=style&index=0&id=99b250d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b250d2",
  null
  
)

export default component.exports